import "./nav-container.scss";

import { Link } from "react-router-dom";
import chevron from "../../assets/icons/chevron-right-double.svg";
import reportIcon from "../../assets/icons/file.svg";
import logoutIcon from "../../assets/icons/log-out.svg";
import chatIcon from "../../assets/icons/message-chat-square.svg";
import settingsIcon from "../../assets/icons/settings.svg";
import profileIcon from "../../assets/icons/user-circle.svg";

import WelcomeName from "../WelcomeName/WelcomeName";

import { IsAdmin, IsSuperAdmin, useAuth } from "../../context/auth.context";
import { appInsights } from "../../services/app-insights.service";
import Button from "../Button/Button";

const NavCollapsed = ({ setCollapseNav, collapseNav }: any) => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    appInsights.trackEvent({
      name: "ButtonClicked",
      properties: {
        buttonName: "LogoutButton",
        user: `${localStorage.getItem("email")}`,
      },
    });
    await logout();
  };

  return (
    <div className="nav__collapsed-container">
      <div className="nav__collapsed-toggle-container">
        <img
          src={chevron}
          alt={"right arrow"}
          className={`nav__toggle-icon ${collapseNav ? "collapsed" : ""}`}
          onClick={() => setCollapseNav(collapseNav)}
        />
      </div>
      <div className="nav__col-icons-container">
      </div>
      <Link
        to="/"
        className={`nav__icon ${collapseNav ? "collapsed settings" : ""}`}
        onClick={() => handleLogout()}
      >
        <img
          src={logoutIcon}
          alt={"logout"}
          className={`nav__icon ${collapseNav ? "collapsed" : ""}`}
        />
        <p className="nav__logout-text">Logout</p>
      </Link>
      {/* <Link
				to="/"
				className={`nav__icon ${collapseNav ? "collapsed settings" : ""}`}
			>
				<img
					src={settingsIcon}
					alt={"settings"}
					className={`nav__icon ${collapseNav ? "collapsed" : ""}`}
				/>
			</Link> */}
      <Link
        to="/"
        className={`nav__icon ${collapseNav ? "collapsed user" : ""}`}
      >
        <img
          src={profileIcon}
          alt={"settings"}
          className={`nav__icon ${
            collapseNav ? "collapsed user-icon" : ""
          } profile-icon`}
        />
      </Link>
    </div>
  );
};

const Nav = (props: any) => {
  const { setCollapseNav, collapseNav } = props;
  const { logout } = useAuth();

  const handleLogout = async () => {
    appInsights.trackEvent({
      name: "ButtonClicked",
      properties: {
        buttonName: "LogoutButton",
        user: `${localStorage.getItem("email")}`,
      },
    });
    await logout();
  };

  return (
    <>
      {!collapseNav ? (
        <div className="nav">
          <div className="nav__icons-container">
            <WelcomeName />
            <img
              src={chevron}
              alt={"right arrow"}
              className="nav__toggle-icon"
              onClick={() => setCollapseNav(collapseNav)}
            />
          </div>
          <div className="nav__block--user">
            <ul className="nav__list">
              <Button
                onClick={() => handleLogout()}
                text={"Log Out"}
                style={{ "--button-bg-color": import.meta.env.VITE_ENV_COLOR }}
              />
            </ul>
          </div>
        </div>
      ) : (
        <NavCollapsed
          setCollapseNav={setCollapseNav}
          collapseNav={collapseNav}
        />
      )}
    </>
  );
};

export default Nav;
